import React from 'react';
import parse from 'html-react-parser';

class MessageList extends React.Component
{
  scrollToBottom = true;

  constructor( props )
  {
    super( props );

    this.scrollDivRef = React.createRef();
  }

  componentDidUpdate()
  {
    if( this.scrollToBottom )
    {
      // Force scroll to the bottom after new content added to keep the latest info visible
      this.scrollDivRef.current.scrollTo( 0, this.scrollDivRef.current.scrollHeight );
    }
  }

  isScrollAtBottom = () =>
  {
    if( !this.scrollDivRef.current )
    {
      return true;
    }

    const scrollTopAtBottomValue = this.scrollDivRef.current.scrollHeight - this.scrollDivRef.current.clientHeight - 3;
    const isAtScrollBottom = this.scrollDivRef.current.scrollTop >= scrollTopAtBottomValue;

    return isAtScrollBottom;
  };

  handleScroll = () =>
  {
    // If user is at the bottom, enable auto-scroll. Otherwise, disable it.
    this.scrollToBottom = this.isScrollAtBottom();
  };

  render()
  {
    let
      {
        messages,
        classNamesPrefix,
        style
      } = this.props;


    let messageElements = [];

    for( let idx = 0; idx < messages.length; idx++ )
    {
      const messageData = messages[ idx ];

      if( messageData.line )
      {
        messageElements.push(
          <div
            className={ classNamesPrefix + "-message-line" }
            key={ "message_" + idx }
          >
            <hr />
          </div>
        );
      }
      else
      {
        let divStyle = null;
        if( messageData.onClick )
        {
          divStyle = { cursor: 'pointer' };
        }

        messageElements.push(
          <div
            className={ classNamesPrefix + "-message-text" }
            key={ "message_" + idx }
            onClick={ messageData.onClick ?? null }
            style={ divStyle }
          >
            { messageData.messageIconPath && ( <img className={ classNamesPrefix + "-message-icon" } src={ messageData.messageIconPath } alt="Message Icon" /> ) }
            { messageData.prefix && ( <span className="message-line-prefix">{ messageData.prefix }</span> ) }
            { parse( messageData.text ) }
          </div>
        );
      }
    }

    let ccsStyle = style != null ? style : {};

    ccsStyle.overflowY = 'auto';

    return (
      <div
        className={ classNamesPrefix + "-container" }
        ref={ this.scrollDivRef }
        style={ ccsStyle }
        onScroll={ this.handleScroll }
      >
        { messageElements }
      </div>
    );
  }
}

export default MessageList;
